var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.774,
    height: 84.774,
    viewBox: "0 0 84.774 84.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_149049",
    "data-name": "Group 149049",
    transform: "translate(-1.002 -1.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102263",
    "data-name": "Path 102263",
    d: "M46.993,2.168a6.158,6.158,0,0,1,8.844,1.754,6.16,6.16,0,0,0,6.658,2.758,6.158,6.158,0,0,1,7.5,5.009,6.16,6.16,0,0,0,5.1,5.1,6.158,6.158,0,0,1,5.009,7.5,6.16,6.16,0,0,0,2.758,6.66,6.158,6.158,0,0,1,1.754,8.844,6.158,6.158,0,0,0,0,7.206,6.158,6.158,0,0,1-1.754,8.844A6.16,6.16,0,0,0,80.1,62.495a6.158,6.158,0,0,1-5.011,7.5,6.16,6.16,0,0,0-5.1,5.1A6.158,6.158,0,0,1,62.5,80.1a6.16,6.16,0,0,0-6.66,2.758,6.158,6.158,0,0,1-8.844,1.754,6.158,6.158,0,0,0-7.206,0,6.158,6.158,0,0,1-8.844-1.754A6.16,6.16,0,0,0,24.285,80.1a6.158,6.158,0,0,1-7.5-5.011,6.16,6.16,0,0,0-5.1-5.1,6.158,6.158,0,0,1-5.009-7.5,6.16,6.16,0,0,0-2.758-6.658,6.158,6.158,0,0,1-1.754-8.844,6.158,6.158,0,0,0,0-7.206,6.158,6.158,0,0,1,1.754-8.844,6.16,6.16,0,0,0,2.758-6.658,6.158,6.158,0,0,1,5.009-7.5,6.16,6.16,0,0,0,5.1-5.1,6.158,6.158,0,0,1,7.5-5.009,6.16,6.16,0,0,0,6.658-2.758,6.158,6.158,0,0,1,8.844-1.754,6.158,6.158,0,0,0,7.206,0Z",
    transform: "translate(0 0)",
    fill: "#b0d3f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9630",
    "data-name": "Ellipse 9630",
    cx: 35.082,
    cy: 35.082,
    r: 35.082,
    transform: "translate(8.308 8.308)",
    fill: "#014cec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102264",
    "data-name": "Path 102264",
    d: "M29.152,48.086a3.587,3.587,0,0,1-2.363-.887L17.224,38.83a3.587,3.587,0,0,1,4.725-5.4l6.556,5.739,14.447-20.64a3.587,3.587,0,1,1,5.878,4.114L32.091,46.556a3.594,3.594,0,0,1-2.511,1.5A3.733,3.733,0,0,1,29.152,48.086Z",
    transform: "translate(10.651 10.846)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmation);
export default __webpack_public_path__ + "static/media/confirmation.60739e571fc2a567779ae05695b93671.svg";
export { ForwardRef as ReactComponent };